import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4036fb70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "section-heading" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "section-main-container mb-8",
    style: _normalizeStyle({ height: _ctx.isExpanded ? 'auto' : 'auto' }),
    "data-aos": "fade-up"
  }, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          xs: 12,
          sm: 12,
          md: 3,
          lg: 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.imageUrl,
                alt: "logo image",
                class: "img-fluid"
              }, null, 8, _hoisted_2)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          xs: 12,
          sm: 12,
          md: 9,
          lg: 9
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.heading), 1),
              (_ctx.isExpanded && !_ctx.content.redirectTo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("b", null, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.content.heading
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.content.text1), 1),
                    _hoisted_6,
                    _createElementVNode("p", null, _toDisplayString(_ctx.content.text2), 1),
                    _createElementVNode("p", {
                      innerHTML: _ctx.content.text3
                    }, null, 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.content.redirectTo)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    elevation: "0",
                    class: "mt-5",
                    onClick: _ctx.toggleExpanded
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isExpanded ? 'Read Less' : 'Read More'), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.content.redirectTo)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    elevation: "0",
                    class: "mt-5",
                    onClick: _ctx.redirect
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Read More ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 4))
}